// Geometri penempatan bangunan di editor: ukuran efektif (rotasi), tabrakan tapak, pencarian bangunan di petak.

// Ukuran efektif penempatan — rotasi ganjil (90°/270°) menukar w×h
export function dimsOf(defs, b) {
  const def = defs.find(d => d.bid === b.bid);
  let w = def?.w || 1, h = def?.h || 1;
  if ((b.rot || 0) % 2 === 1) [w, h] = [h, w];
  return [w, h];
}

export function occupied(defs, list, gx, gy, w, h, excludeIdx = -1) {
  return (list || []).some((b, i) => {
    if (i === excludeIdx) return false;
    const [bw, bh] = dimsOf(defs, b);
    return gx < b.x + bw && gx + w > b.x && gy < b.y + bh && gy + h > b.y;
  });
}

export function buildingIndexAt(defs, buildings, gx, gy) {
  return (buildings || []).findIndex(b => {
    const [bw, bh] = dimsOf(defs, b);
    return gx >= b.x && gy >= b.y && gx < b.x + bw && gy < b.y + bh;
  });
}
